/* eslint-disable max-len */
export const titleOne = '1. Ingresá Alias, CBU, CVU o Email del nuevo contacto'
export const subTitleOne =
  'Si ingresás un alias, recordá que debe contener entre 6 y 20 caracteres (letras, números, guión y punto)'
export const titleTwo = '2. Confirmá los datos del nuevo contacto ingresado'
export const subTitleTwo =
  'Podrás agendar la cuenta para operaciones futuras o bien, realizar una transferencia y agendarlo.'
export const titleThree = '3. Ingresá el código que recibiste en tu celular'
export const subTitleThree =
  'Ingresá el código de 6 dígitos envíado a tu celular.'
